import { call, put } from "redux-saga/effects";

import actions from "@/actions";

import changeMode from "./change-mode";

/**
 * Highlights a row or column on the map and switches to view mode.
 *
 * @param root0 - The action.
 * @param root0.payload - The highlight configuration (row/column).
 * @yields Dispatches highlight and mode change actions.
 */
function* highlightMap({ payload }) {
    try {
        yield put(actions.map.general.setHighlight(payload));
        yield call(changeMode, "view", {});
    } catch (err) {
        // eslint-disable-next-line no-console
        console.log("err on highlighting map:", err);
    }
}

export default highlightMap;
